// Seri chart & helper peta compare voyage. Nol import biar bisa dites node.

export const SIDE_COLORS = { a: '#0d6efd', b: '#fd7e14' };

const HOUR_MS = 3600000;
const TICK_STEPS_HOURS = [1, 2, 3, 6, 12, 24, 48, 72, 168, 336, 720];

// sama kayak detail voyage: > 7 hari pakai DAY, tapi diambil dari voyage terpanjang
export function sharedAggregation(durationA, durationB) {
  const longest = Math.max(Number(durationA) || 0, Number(durationB) || 0);
  return {
    aggregatedUnit: longest > 7 * 24 * 3600 ? 'DAY' : 'HOUR',
    aggregatedLength: 1,
  };
}

export function bucketSeconds(unit) {
  return unit === 'DAY' ? 86400 : 3600;
}

// 0h, 5h, 1d, 1d 6h
export function formatElapsed(ms) {
  const hours = Math.round(Math.max(0, Number(ms) || 0) / HOUR_MS);
  const days = Math.floor(hours / 24);
  const rest = hours % 24;
  if (!days) return `${rest}h`;
  return rest ? `${days}d ${rest}h` : `${days}d`;
}

export function elapsedTicks(fromMs, toMs, maxTicks) {
  if (!(toMs > fromMs)) return [fromMs];
  const spanHours = (toMs - fromMs) / HOUR_MS;
  const stepHours = TICK_STEPS_HOURS.find((step) => spanHours / step <= maxTicks)
    || TICK_STEPS_HOURS[TICK_STEPS_HOURS.length - 1];
  const stepMs = stepHours * HOUR_MS;
  const ticks = [];
  for (let tick = Math.ceil(fromMs / stepMs) * stepMs; tick <= toMs; tick += stepMs) {
    ticks.push(tick);
  }
  return ticks;
}

// baris bucket -> offset ms sejak voyage mulai, dibulatkan ke bucket biar A & B sejajar
export function buildCompareSeries({ sides, bucketSeconds: bucket, metrics }) {
  const aligned = sides.map(({ side, rows, startSeconds }) => {
    const byElapsed = new Map();
    (rows || []).forEach((row) => {
      if (!Number.isFinite(row.timestamp) || !Number.isFinite(startSeconds)) return;
      const steps = Math.max(0, Math.round((row.timestamp - startSeconds) / bucket));
      byElapsed.set(steps * bucket * 1000, row);
    });
    return { side, byElapsed };
  });

  const timestamps = [...new Set(aligned.flatMap(({ byElapsed }) => [...byElapsed.keys()]))]
    .sort((left, right) => left - right);

  const datasets = aligned.flatMap(({ side, byElapsed }) => metrics.map((metric) => {
    const data = timestamps.map((ms) => {
      const row = byElapsed.get(ms);
      const value = row ? row[metric.field] : null;
      return Number.isFinite(value) ? value : null;
    });
    return {
      id: `${side}-${metric.field}`,
      side,
      name: `${side.toUpperCase()} · ${metric.name}`,
      color: SIDE_COLORS[side],
      dash: metric.dash || null,
      data,
      // extractor detail ngisi 0 kalau data gak ada
      status: data.some((value) => value !== null && value !== 0) ? 'ok' : 'empty',
    };
  }));

  return { timestamps, datasets };
}

// titik trail (urut timestamp) terdekat ke offset hover
export function nearestIndexByElapsed(points, startSeconds, elapsedMs, toleranceMs = HOUR_MS) {
  if (!points || !points.length || !Number.isFinite(startSeconds) || !Number.isFinite(elapsedMs)) return -1;
  const target = startSeconds * 1000 + elapsedMs;
  const distance = (index) => Math.abs(points[index].timestamp * 1000 - target);
  let low = 0;
  let high = points.length - 1;
  while (low < high) {
    const mid = Math.floor((low + high) / 2);
    if (points[mid].timestamp * 1000 < target) low = mid + 1;
    else high = mid;
  }
  const index = low > 0 && distance(low - 1) <= distance(low) ? low - 1 : low;
  return distance(index) <= toleranceMs ? index : -1;
}
